module.exports = __webpack_public_path__ + "static/media/bulbimage.6b9bf21c.png";